import React from 'react';

class VBPopup extends React.Component {
    constructor(props){
        super();
        this.state ={
            visible: props.visible
           
        }
    }
    
  
    render(){
       
        return this.state.visible ? 
        
        <div className="vbPopup">
		    <div className={this.props.center ? "box center" : "box"}>
			    {this.props.title}
			    {this.props.desc}
			    <button onClick={() => {this.setState({visible:false})}} className="btn blue">Stäng</button>
			    {this.props.removeLink ? null : <a href={this.props.buttonLink} className="btn orange">{this.props.buttonText}</a> }
		    </div>
        </div>
        :
        null
	;
    }
}

export default VBPopup;